import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import config from "@/config/config";
import axios from "@/plugins/axios";
import "./registerServiceWorker";

Vue.config.productionTip = false;
Vue.use(config);
Vue.use(axios);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
